import { asOfDateAtom } from "@/features/Metrics/state/Metrics.state";
import { useAtomValue } from "jotai";
import { InfoTooltip } from "@/ui/molecules/InfoTooltip";
import { formatAsOfDate } from "../../helpers/formatAsOfDate";
import { BALANCE_SHEET_CODES, INCOME_STATEMENT_CODES } from "./codes";
import { SummaryTable } from "./SummaryTable";
import { DeltaType } from "@/features/Metrics/Metrics.types";

export function SummaryFinancials() {
    const asOfDate = useAtomValue(asOfDateAtom);

    return (
        <div className="space-y-8">
            <div className="body-s flex items-center gap-1">
                <span className="subdued italic">
                    Data as of {formatAsOfDate(asOfDate.format("MMM D, YYYY"))}
                </span>
                <InfoTooltip>
                    The data displayed is from the last closed, complete
                    calendar period available in the company&apos;s accounting
                    system. Hum does not display partial period data.
                </InfoTooltip>
            </div>
            <SummaryTable
                gridId="summary-income-statement-grid"
                codes={INCOME_STATEMENT_CODES}
                title="Summary Income Statement"
                deltaType={DeltaType.CUMULATIVE}
            />
            <SummaryTable
                gridId="summary-balance-sheet-grid"
                codes={BALANCE_SHEET_CODES}
                title="Summary Balance Sheet"
            />
        </div>
    );
}
